import { ElMessage } from 'element-plus'
export default {
  install: (app: any, options: object) => {
    app.config.errorHandler = (err: any, vm: any, info: any) => {
      console.error('vue errorHandler -> err', err)
      console.error('vue errorHandler -> info', info)
      // ElMessage.error(err?.message)
      // handle error
      // `info` is a Vue-specific error info, e.g. which lifecycle hook
      // the error was found in
    }
    app.config.warnHandler = function (msg: any, vm: any, trace: any) {
      // console.warn('vue warnHandler -> msg', msg)
      // console.warn('vue warnHandler -> trace', trace)
      // `trace` is the component hierarchy trace
    }
    window.onerror = function (
      event: Event | string,
      source?: string,
      lineno?: number,
      colno?: number,
      error?: Error
    ) {
      //   console.error('window.onerror -> event', event)
      //   console.error('window.onerror -> source', source)
      //   console.error('window.onerror -> error', error)
      //   ElMessage.error(error?.message)
    }
    window.addEventListener(
      'error',
      function (event: any) {
        // const errMsg = `资源${event.srcElement?.currentSrc || ''}加载失败`
        // console.error('window.addEventListener -> error ', errMsg)
        // ElMessage.error(errMsg)
      },
      true
    )
  },
}
